import { render } from "./CurrentStudentView.vue?vue&type=template&id=fd1879f4"
import script from "./CurrentStudentView.vue?vue&type=script&lang=js"
export * from "./CurrentStudentView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__